import { ChartSeriesData } from "@components/Chart/highcharts/common";

export const prepareChartData = <T extends { date: string | Date }>(
  data: T[],
  seriesToShow: string[],
  seriesKeyMap: Readonly<Record<string, keyof T & string>>,
  chartColors: Record<string, string>
): ChartSeriesData[] => {
  const objectKeys = seriesToShow.map((type) => seriesKeyMap[type]);

  const hasTrendColors =
    seriesToShow.includes("all") &&
    chartColors["positive"] != null &&
    chartColors["negative"] != null;

  const valueKey = seriesKeyMap["all"];
  const startValue = hasTrendColors
    ? (((data[0] as T)?.[valueKey as keyof T] as number | undefined) ?? 0)
    : 0;
  const endValue = hasTrendColors
    ? (((data[data.length - 1] as T)?.[valueKey as keyof T] as
        | number
        | undefined) ?? 0)
    : 0;
  const trendColor = hasTrendColors
    ? endValue >= startValue
      ? chartColors["positive"]
      : chartColors["negative"]
    : null;

  const mainLineColor = trendColor ?? chartColors["mainLine"];
  const mainAreaColor = trendColor ?? chartColors["mainArea"];

  const initialFormattedData = seriesToShow.reduce(
    (acc, key) => {
      const objectKey = seriesKeyMap[key];
      const colorKey =
        key === "all"
          ? "mainLine"
          : key === "comparison"
            ? "secondaryLine"
            : key;
      acc[objectKey] = {
        name: key,
        data: [],
        type: key === "all" ? "area" : "spline",
        color: key === "all" ? mainLineColor : chartColors[colorKey],
        areaColor: key === "all" ? mainAreaColor : undefined,
      };
      return acc;
    },
    {} as Record<string, ChartSeriesData>
  );

  data.forEach((d) => {
    const timestamp = new Date(d.date).getTime();
    objectKeys.forEach((key) => {
      initialFormattedData[key].data.push([
        timestamp,
        d[key] as unknown as number,
      ]);
    });
  });

  return Object.values(initialFormattedData);
};
